module.exports = __webpack_public_path__ + "img/CyberBanner.d74f2c79.png";